import React from 'react';
import styles from './profiles-filter.module.css';
interface AgeFilterProps {
    value: number | null; // центральное значение фильтра
    onChange: (value: number | null) => void;
    min?: number;
    max?: number;
    fuzz?: number; // диапазон ±fuzz лет
}

const AgeFilter: React.FC<AgeFilterProps> = ({
    value,
    onChange,
    min = 18,
    max = 80,
    fuzz = 4,
}) => {
    const effectiveFuzz = value && value <= 30 ? 3 : fuzz;

    const displayRange = value
        ? `${Math.max(min, value - effectiveFuzz)}–${Math.min(max, value + effectiveFuzz)}`
        : 'не указан';

    return (
        <div className="age-filter">
            {/* Заголовок + кнопка сброса */}
            <div className="flex justify-between items-center mb-2">
                <h3 className={styles.h3}>Возраст</h3>
                {value !== null && (
                    <button
                        type="button"
                        className="text-sm text-gray-500 hover:text-red-500"
                        onClick={() => onChange(null)}
                    >
                        Сбросить
                    </button>
                )}
            </div>

            {/* Диапазон отображается, но не точный возраст */}
            <div className="mb-2 text-gray-700 text-sm">
                {`~${displayRange}`}
            </div>

            {/* Слайдер */}
            <input
                type="range"
                min={min}
                max={max}
                value={value ?? min}
                onChange={e => onChange(Number(e.target.value))}
                className="w-full h-2 bg-gray-200 rounded-lg accent-[var(--primary-color)] cursor-pointer"
            />
        </div>
    );
};

export default AgeFilter;